/* eslint-disable */
import moment from "moment";
import 'moment/locale/ru';

import './isAbsent.css';
import template from './template.html';

var IsAbsentViewModel = Backbone.Epoxy.Model.extend({
	defaults:{
		tabsDate: null
	}
});

let IsAbsentView = Backbone.Epoxy.View.extend({
	computeds: {
		criteriaStr: {
			deps: ['searchData','tabsDate'],
			get: function (searchData, tabsDate) {
				var criteriaStr = "",
					data= {
						checkInDateRange: searchData.get('checkInDateRange'),
						nightRange: searchData.get('nightRange'),
						touristGroup: searchData.get('touristGroup')
					};
				if(data.checkInDateRange && data.nightRange && data.touristGroup){
					criteriaStr = createStr(data)
				}
				function createStr(data){
					var touristGroup = data.touristGroup.toJSON(),
						nightRange = data.nightRange.toJSON(),
						checkInDateRange = data.checkInDateRange.toJSON(),
						child = touristGroup.infants + touristGroup.kids,
						dateStr =  moment(checkInDateRange.from),
						result = "";
					result += touristGroup.adults + " взрослы" + touristGroup.adults.wordEnding("й;х;х");
					if(child){
						result += " " + child + " " + child.wordEnding("ребенок;детей;детей")
					}
					if(tabsDate){
						dateStr =  moment(tabsDate,'YYYY-MM-DD')
					}

					result += ", <span class='js-isabsent-data-str'>" + dateStr.format("DD MMMM") + "</span> ("+ nightRange.from + " ноч" + nightRange.from.wordEnding("ь;и;ей") +")";
					return result
				}
				return criteriaStr
			}
		}
	},
	viewModel: new IsAbsentViewModel(),
	bindings: {
		".isAbsent__criteria": "html:criteriaStr"
	},
	initialize: function () {
		this.$el.append(template());
		this.initModelEvents();
		this.scrollToBlock();
	},
	scrollToBlock: function () {
		var top = $('.hotelSerpContainer__tabs-content').offset().top;
		$("html, body").animate({scrollTop:top}, 500);
	},
	initModelEvents: function () {
		var self = this;
		this.model.get("filterCriteria").on("change:selectedTabDate", function (model,value) {
			self.viewModel.set("tabsDate", value)
		})
	}
});

export default IsAbsentView;